export default __webpack_public_path__ + "static/media/door-icon.8eee543d.svg";